"use client";

import { useEffect, useState } from "react";

//#region [Props]
type MailChimpScriptsProps = {
};
//#endregion

//#region [Component]
export default function MailChimpScripts({ }: MailChimpScriptsProps) {
    const [doRender, setRender] = useState(false);
    useEffect(() => {
        setRender(true);
    }, []);
    if (!doRender) {
        return null;
    }
    return <>
        {process.env.AD_ENV_NAME === "PROD" && <script id="mcjs" dangerouslySetInnerHTML={{ __html: `!function(c,h,i,m,p){m=c.createElement(h),p=c.getElementsByTagName(h)[0],m.async=1,m.src=i,p.parentNode.insertBefore(m,p)}(document,"script","https://chimpstatic.com/mcjs-connected/js/users/e0cead56b303960f1671cd15c/0a1da376d8c507254d7d1421c.js");` }}></script>}
        {process.env.AD_ENV_NAME === "TEST" && <script id="mcjs" dangerouslySetInnerHTML={{ __html: `!function(c,h,i,m,p){m=c.createElement(h),p=c.getElementsByTagName(h)[0],m.async=1,m.src=i,p.parentNode.insertBefore(m,p)}(document,"script","https://chimpstatic.com/mcjs-connected/js/users/e0cead56b303960f1671cd15c/b5848b85b33750837e3dcd8fb.js");` }}></script>}
    </>;
}
//#endregion
